import { ReactNode } from "react";
import FloatingChat from "../admin/FloatingChat";

interface AdminLayoutProps {
  children: ReactNode;
}

const AdminLayout = ({ children }: AdminLayoutProps) => {
  return (
    <div className="min-h-screen bg-background">
      {children}
      <FloatingChat />
    </div>
  );
};

export default AdminLayout;
